module.exports = __webpack_public_path__ + "img/comparison.37c2a394.webp";